import type { ReactNode, JSX} from "react";
import { cn } from "./cn";
import { Row } from "./Row";
import { Stack } from "./Stack";
import { Text } from "./Text";

export interface ActivityRowProps {
  /** Leading element: IconBox, DateBadge, or any visual marker */
  readonly leading: ReactNode;
  /** Primary text */
  readonly title: string;
  /** Secondary text */
  readonly subtitle?: string;
  /** Tertiary metadata text */
  readonly meta?: string;
  /** Extra className */
  readonly className?: string;
}

/**
 * A row with a leading icon/badge area and stacked text content.
 * Used for email entries, meeting entries, activity feed items.
 */
export function ActivityRow({ leading, title, subtitle, meta, className }: ActivityRowProps): JSX.Element {
  return (
    <Row gap={3} align="start" className={cn("py-2", className)}>
      {leading}
      <Stack gap={0.5}>
        <Text variant="body">{title}</Text>
        {subtitle ? <Text variant="caption" color="tertiary">{subtitle}</Text> : null}
        {meta ? <Text variant="tiny" color="tertiary">{meta}</Text> : null}
      </Stack>
    </Row>
  );
}
